import { useMutation, UseMutationResult } from 'react-query';

import { getTokenWithType } from './useAuth';

import { uploadExternalDocument } from 'utils/urls';

export type TResult = string;
export type TVariables = {
  account: string;
  filePath: any;
  file: File;
};
export type TError = {
  message: string;
};
export type TSnapshot = unknown;

function useUploadExternalDocument(
  setProgress?: (progress: number) => void,
): UseMutationResult<TResult, TError, TVariables, TSnapshot> {
  function updateProgress(evt: any) {
    if (evt.lengthComputable) {
      // evt.loaded the bytes the browser received
      // evt.total the total bytes set by the header
      // jQuery UI progress bar to show the progress on screen
      const percentComplete = (evt.loaded / evt.total) * 100;
      setProgress && setProgress(percentComplete);
    }
  }

  return useMutation(async ({ account, filePath, file }: TVariables) => {
    try {
      await new Promise((res, rej) => {
        const formData: FormData = new FormData();
        formData.append('file', file);
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', uploadExternalDocument(account, filePath));
        xhr.setRequestHeader('Authorization', getTokenWithType());
        xhr.onreadystatechange = function (aEvt: any) {
          if (
            aEvt.currentTarget.status >= 200 &&
            aEvt.currentTarget.status <= 210
          ) {
            res(aEvt.currentTarget.response);
          } else {
            rej();
          }
        };
        xhr.onprogress = updateProgress;
        xhr.upload.addEventListener('progress', updateProgress);
        xhr.onerror = e => rej(e);
        xhr.send(formData);
      });
    } catch (e) {
      console.log('EEEEEE', e);
      throw e;
    }
    return `AccountFolders/${account}/Documents/${file.name}`;
  });
}

export { useUploadExternalDocument };
